<div class="help-page">
  <header class="help-topbar">
    <a class="help-back" href="#" (click)="back($event)">
      <span aria-hidden="true">←</span>Volver al formulario
    </a>
    <span class="help-crumb">Ayuda · Número de soporte</span>
  </header>

  <main class="help-wrap help-intro">
    <h1>¿Cómo saber mi número de soporte?</h1>
    <span class="help-rule"></span>
    <p class="help-lead">Son 9 caracteres: una letra seguida de 8 números. Dónde aparece, y con qué letra empieza, depende de tu documento.</p>

    <div class="help-cols">
      <div class="help-card">
        <span class="help-pill">Tarjeta de extranjero</span>
        <div class="help-imgs">
          <figure class="help-fig">
            <img [src]="'img/illustrations/support-number-tie.webp' | assetUrl" width="1020" height="601" loading="lazy" alt="Tarjeta de extranjero con dos recuadros: uno amarillo sobre el número de soporte, arriba a la derecha, y uno rojo sobre el NIE, abajo a la izquierda">
            <ul class="help-legend">
              <li><span class="help-swatch is-yellow" aria-hidden="true"></span>Número de soporte</li>
              <li><span class="help-swatch" aria-hidden="true"></span>NIE</li>
            </ul>
          </figure>
        </div>
        <div class="help-foot">
          <p>El <strong>número de soporte</strong> está arriba a la derecha. El código de abajo a la izquierda es tu NIE, no lo confundas.</p>
          <div class="help-ex">
            <span class="help-ex-label">Ejemplo</span>
            <span class="help-chip">E00000000</span>
          </div>
        </div>
      </div>

      <div class="help-card">
        <span class="help-pill">Permiso de residencia</span>
        <div class="help-imgs">
          <figure class="help-fig">
            <img [src]="'img/illustrations/support-number-residencia.webp' | assetUrl" width="1020" height="595" loading="lazy" alt="Permiso de residencia con dos recuadros: uno amarillo sobre el número de soporte, arriba a la derecha, y uno rojo sobre el NIE, en la parte inferior">
            <ul class="help-legend">
              <li><span class="help-swatch is-yellow" aria-hidden="true"></span>Número de soporte</li>
              <li><span class="help-swatch" aria-hidden="true"></span>NIE</li>
            </ul>
          </figure>
        </div>
        <div class="help-foot">
          <p>El <strong>número de soporte</strong> está arriba a la derecha. El código de abajo a la izquierda es tu NIE, no lo confundas.</p>
          <div class="help-ex">
            <span class="help-ex-label">Ejemplo</span>
            <span class="help-chip">E00000000</span>
          </div>
        </div>
      </div>

      <div class="help-card is-wide">
        <span class="help-pill">Certificado de registro de ciudadano de la UE</span>
        <div class="help-imgs is-row">
          <figure class="help-fig">
            <img [src]="'img/illustrations/support-number-certificado-tarjeta.webp' | assetUrl" width="1020" height="619" loading="lazy" alt="Reverso de la tarjeta verde de certificado de registro, con un recuadro rojo sobre el número de soporte, abajo a la derecha">
            <ul class="help-legend">
              <li><span class="help-swatch" aria-hidden="true"></span>Número de soporte · tarjeta verde</li>
            </ul>
          </figure>
          <figure class="help-fig">
            <img [src]="'img/illustrations/support-number-certificado-hoja.webp' | assetUrl" width="1020" height="1322" loading="lazy" alt="Certificado de registro en hoja A4, con un recuadro rojo sobre el número de soporte, arriba a la derecha">
            <ul class="help-legend">
              <li><span class="help-swatch" aria-hidden="true"></span>Número de soporte · hoja A4</li>
            </ul>
          </figure>
        </div>
        <div class="help-foot">
          <p>Aquí el número empieza por <strong>C</strong>, no por E, y en el documento solo aparecen los dígitos. Está abajo a la derecha en la tarjeta verde y arriba a la derecha en la hoja A4.</p>
          <div class="help-ex">
            <span class="help-ex-label">Ejemplo</span>
            <span class="help-chip">9999999</span>
            <span class="help-arrow" aria-hidden="true">→</span>
            <span class="help-chip">C09999999</span>
          </div>
        </div>
      </div>
    </div>
  </main>

  <div class="help-note-wrap">
    <div class="help-note">
      <i aria-hidden="true">i</i>
      <div>
        <p class="help-note-title">Importante</p>
        <p>En el caso de que el número de soporte que figura en su documento tenga menos de 8 caracteres numéricos, ha de introducir tantos ceros como caracteres numéricos falten a continuación de la letra. Ejemplo: <strong class="help-tabular">E1234567 → E01234567</strong>.</p>
      </div>
    </div>
  </div>

  <a class="help-cta" href="#" (click)="back($event)">Volver al formulario</a>
</div>
